<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX331, CX431, MC3224, MC3326, MC3426 &eacute;s XC2326 multifunkci&oacute;s k&eacute;sz&uuml;l&eacute;k">
     CX331, CX431, MC3224, MC3326, MC3426 &eacute;s XC2326 multifunkci&oacute;s k&eacute;sz&uuml;l&eacute;k
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_hu" title="Biztons&aacute;gi inform&aacute;ci&oacute;k">
     Biztons&aacute;gi inform&aacute;ci&oacute;k
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvenci&oacute;k">
      Konvenci&oacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="Term&eacute;knyilatkozatok">
      Term&eacute;knyilatkozatok
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_hu" title="Inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l">
     Inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l
    </a>
   </p>
   <div id="divd0e177">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_hu" title="Tov&aacute;bbi inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l">
      Tov&aacute;bbi inform&aacute;ci&oacute;k a nyomtat&oacute;r&oacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_hu" title="A nyomtat&oacute; sorozatsz&aacute;m&aacute;nak megtal&aacute;l&aacute;sa">
      A nyomtat&oacute; sorozatsz&aacute;m&aacute;nak megtal&aacute;l&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_hu" title="Nyomtat&oacute;be&aacute;ll&iacute;t&aacute;sok">
      Nyomtat&oacute;be&aacute;ll&iacute;t&aacute;sok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_hu" title="A kezelőpanel haszn&aacute;lata">
      A kezelőpanel haszn&aacute;lata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_hu" title="A kezdők&eacute;pernyő testreszab&aacute;sa">
      A kezdők&eacute;pernyő testreszab&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-keyboard-on-display-topic.html#changing-language-of-keyboard-on-display_hu" title="Kijelző billentyűzet nyelv&eacute;nek m&oacute;dos&iacute;t&aacute;sa">
      Kijelző billentyűzet nyelv&eacute;nek m&oacute;dos&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_hu" title="A jelzőf&eacute;ny &aacute;llapot&aacute;nak &eacute;rtelmez&eacute;se">
      A jelzőf&eacute;ny &aacute;llapot&aacute;nak &eacute;rtelmez&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e600" title="Pap&iacute;r kiv&aacute;laszt&aacute;sa">
      Pap&iacute;r kiv&aacute;laszt&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_hu" title="Be&aacute;ll&iacute;t&aacute;s, telep&iacute;t&eacute;s &eacute;s konfigur&aacute;l&aacute;s">
     Be&aacute;ll&iacute;t&aacute;s, telep&iacute;t&eacute;s &eacute;s konfigur&aacute;l&aacute;s
    </a>
   </p>
   <div id="divd0e1461">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_hu" title="Nyomtat&oacute; hely&eacute;nek kiv&aacute;laszt&aacute;sa">
      Nyomtat&oacute; hely&eacute;nek kiv&aacute;laszt&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_hu" title="K&aacute;belek csatlakoztat&aacute;sa">
      K&aacute;belek csatlakoztat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_hu" title="K&uuml;l&ouml;n megv&aacute;s&aacute;rolhat&oacute; t&aacute;lc&aacute;k beszerel&eacute;se">
      K&uuml;l&ouml;n megv&aacute;s&aacute;rolhat&oacute; t&aacute;lc&aacute;k beszerel&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1674" title="A kezdők&eacute;pernyő-alkalmaz&aacute;sok be&aacute;ll&iacute;t&aacute;sa &eacute;s haszn&aacute;lata">
      A kezdők&eacute;pernyő-alkalmaz&aacute;sok be&aacute;ll&iacute;t&aacute;sa &eacute;s haszn&aacute;lata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1798" title="Nyomtat&oacute; be&aacute;ll&iacute;t&aacute;sa faxol&aacute;sra">
      Nyomtat&oacute; be&aacute;ll&iacute;t&aacute;sa faxol&aacute;sra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_hu" title="E-mail SMTP-be&aacute;ll&iacute;t&aacute;sok konfigur&aacute;l&aacute;sa">
      E-mail SMTP-be&aacute;ll&iacute;t&aacute;sok konfigur&aacute;l&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e3818" title="Pap&iacute;r &eacute;s speci&aacute;lis adathordoz&oacute; bet&ouml;lt&eacute;se">
      Pap&iacute;r &eacute;s speci&aacute;lis adathordoz&oacute; bet&ouml;lt&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3987" title="Szoftver, illesztőprogramok &eacute;s firmware telep&iacute;t&eacute;se, illetve friss&iacute;t&eacute;se">
      Szoftver, illesztőprogramok &eacute;s firmware telep&iacute;t&eacute;se, illetve friss&iacute;t&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-options-topic.html#available-options_hu" title="Rendelkez&eacute;sre &aacute;ll&oacute; opci&oacute;k">
      Rendelkez&eacute;sre &aacute;ll&oacute; opci&oacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-wireless-front-solutions-module-topic.html#d0e4279" title="H&aacute;l&oacute;zatok">
      H&aacute;l&oacute;zatok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_hu" title="Men&uuml;be&aacute;ll&iacute;t&aacute;sok oldal nyomtat&aacute;sa">
      Men&uuml;be&aacute;ll&iacute;t&aacute;sok oldal nyomtat&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_hu" title="A nyomtat&oacute; biztons&aacute;ga">
     A nyomtat&oacute; biztons&aacute;ga
    </a>
   </p>
   <div id="divd0e4693">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_hu" title="Nyomtat&oacute;mem&oacute;ria t&ouml;rl&eacute;se">
      Nyomtat&oacute;mem&oacute;ria t&ouml;rl&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_hu" title="Gy&aacute;ri alap&eacute;rtelmezett &eacute;rt&eacute;kek vissza&aacute;ll&iacute;t&aacute;sa">
      Gy&aacute;ri alap&eacute;rtelmezett &eacute;rt&eacute;kek vissza&aacute;ll&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_hu" title="T&ouml;r&ouml;lhetős&eacute;gi nyilatkozat">
      T&ouml;r&ouml;lhetős&eacute;gi nyilatkozat
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_hu" title="Nyomtat&aacute;s">
     Nyomtat&aacute;s
    </a>
   </p>
   <div id="divd0e4816">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_hu" title="Nyomtat&aacute;s a sz&aacute;m&iacute;t&oacute;g&eacute;pről">
      Nyomtat&aacute;s a sz&aacute;m&iacute;t&oacute;g&eacute;pről
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4842" title="Nyomtat&aacute;s mobileszk&ouml;zről">
      Nyomtat&aacute;s mobileszk&ouml;zről
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_hu" title="Nyomtat&aacute;s flash-meghajt&oacute;r&oacute;l">
      Nyomtat&aacute;s flash-meghajt&oacute;r&oacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_hu" title="T&aacute;mogatott flash meghajt&oacute;k &eacute;s f&aacute;jlt&iacute;pusok">
      T&aacute;mogatott flash meghajt&oacute;k &eacute;s f&aacute;jlt&iacute;pusok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_hu" title="Titkos&iacute;tott feladatok konfigur&aacute;l&aacute;sa">
      Titkos&iacute;tott feladatok konfigur&aacute;l&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_hu" title="Titkos&iacute;tott &eacute;s m&aacute;s felf&uuml;ggesztett feladatok nyomtat&aacute;sa">
      Titkos&iacute;tott &eacute;s m&aacute;s felf&uuml;ggesztett feladatok nyomtat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_hu" title="Nyomtat&aacute;s Cloud Connector-profilb&oacute;l">
      Nyomtat&aacute;s Cloud Connector-profilb&oacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_hu" title="Betűt&iacute;pusmint&aacute;k list&aacute;j&aacute;nak nyomtat&aacute;sa">
      Betűt&iacute;pusmint&aacute;k list&aacute;j&aacute;nak nyomtat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_hu" title="Elv&aacute;laszt&oacute;lapok m&aacute;solatok k&ouml;z&eacute; helyez&eacute;se">
      Elv&aacute;laszt&oacute;lapok m&aacute;solatok k&ouml;z&eacute; helyez&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_hu" title="Nyomtat&aacute;si feladat t&ouml;rl&eacute;se">
      Nyomtat&aacute;si feladat t&ouml;rl&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_hu" title="Toner s&ouml;t&eacute;ts&eacute;g&eacute;nek be&aacute;ll&iacute;t&aacute;sa">
      Toner s&ouml;t&eacute;ts&eacute;g&eacute;nek be&aacute;ll&iacute;t&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_hu" title="M&aacute;sol&aacute;s">
     M&aacute;sol&aacute;s
    </a>
   </p>
   <div id="divd0e5457">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_hu" title="Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata">
      Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_hu" title="M&aacute;solatok k&eacute;sz&iacute;t&eacute;se">
      M&aacute;solatok k&eacute;sz&iacute;t&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_hu" title="F&eacute;nyk&eacute;pm&aacute;sol&aacute;s">
      F&eacute;nyk&eacute;pm&aacute;sol&aacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_hu" title="M&aacute;sol&aacute;s fejl&eacute;ces pap&iacute;rra">
      M&aacute;sol&aacute;s fejl&eacute;ces pap&iacute;rra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_hu" title="M&aacute;sol&aacute;s a pap&iacute;r mindk&eacute;t oldal&aacute;ra">
      M&aacute;sol&aacute;s a pap&iacute;r mindk&eacute;t oldal&aacute;ra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_hu" title="A m&aacute;solatok kicsiny&iacute;t&eacute;se &eacute;s nagy&iacute;t&aacute;sa">
      A m&aacute;solatok kicsiny&iacute;t&eacute;se &eacute;s nagy&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_hu" title="T&ouml;bb oldal m&aacute;sol&aacute;sa egyetlen lapra">
      T&ouml;bb oldal m&aacute;sol&aacute;sa egyetlen lapra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_hu" title="P&eacute;ld&aacute;nyok lev&aacute;logat&aacute;sa">
      P&eacute;ld&aacute;nyok lev&aacute;logat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_hu" title="K&aacute;rty&aacute;k m&aacute;sol&aacute;sa">
      K&aacute;rty&aacute;k m&aacute;sol&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_hu" title="M&aacute;sol&aacute;si parancsikon l&eacute;trehoz&aacute;sa">
      M&aacute;sol&aacute;si parancsikon l&eacute;trehoz&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_hu" title="E-mail">
     E-mail
    </a>
   </p>
   <div id="divd0e5743">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_hu" title="Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata">
      Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_hu" title="E-mail k&uuml;ld&eacute;se">
      E-mail k&uuml;ld&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_hu" title="E-mail parancsikon l&eacute;trehoz&aacute;sa">
      E-mail parancsikon l&eacute;trehoz&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_hu" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e5861">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_hu" title="Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata">
      Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_hu" title="Faxk&uuml;ld&eacute;s">
      Faxk&uuml;ld&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_hu" title="Fax be&uuml;temez&eacute;se">
      Fax be&uuml;temez&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_hu" title="Faxel&eacute;r&eacute;si &uacute;tvonal parancsikon l&eacute;trehoz&aacute;sa">
      Faxel&eacute;r&eacute;si &uacute;tvonal parancsikon l&eacute;trehoz&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_hu" title="A fax felbont&aacute;s&aacute;nak m&oacute;dos&iacute;t&aacute;sa">
      A fax felbont&aacute;s&aacute;nak m&oacute;dos&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_hu" title="Fax s&ouml;t&eacute;ts&eacute;g&eacute;nek m&oacute;dos&iacute;t&aacute;sa">
      Fax s&ouml;t&eacute;ts&eacute;g&eacute;nek m&oacute;dos&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_hu" title="Faxnapl&oacute; nyomtat&aacute;sa">
      Faxnapl&oacute; nyomtat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_hu" title="K&eacute;retlen faxok blokkol&aacute;sa">
      K&eacute;retlen faxok blokkol&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_hu" title="Faxok tart&aacute;sa">
      Faxok tart&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_hu" title="Fax tov&aacute;bb&iacute;t&aacute;sa">
      Fax tov&aacute;bb&iacute;t&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_hu" title="Beolvas&aacute;s">
     Beolvas&aacute;s
    </a>
   </p>
   <div id="divd0e6241">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_hu" title="Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata">
      Az automatikus lapadagol&oacute; &eacute;s a lapolvas&oacute; &uuml;veglapj&aacute;nak haszn&aacute;lata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_hu" title="Beolvas&aacute;s sz&aacute;m&iacute;t&oacute;g&eacute;pre">
      Beolvas&aacute;s sz&aacute;m&iacute;t&oacute;g&eacute;pre
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_hu" title="Beolvas&aacute;s FTP-kiszolg&aacute;l&oacute;ra parancsikon seg&iacute;ts&eacute;g&eacute;vel">
      Beolvas&aacute;s FTP-kiszolg&aacute;l&oacute;ra parancsikon seg&iacute;ts&eacute;g&eacute;vel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_hu" title="Beolvas&aacute;s h&aacute;l&oacute;zati mapp&aacute;ba parancsikon haszn&aacute;lat&aacute;val">
      Beolvas&aacute;s h&aacute;l&oacute;zati mapp&aacute;ba parancsikon haszn&aacute;lat&aacute;val
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_hu" title="Beolvas&aacute;s flash-meghajt&oacute;ra">
      Beolvas&aacute;s flash-meghajt&oacute;ra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_hu" title="Beolvas&aacute;s Cloud Connector-profilba">
      Beolvas&aacute;s Cloud Connector-profilba
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_hu" title="A nyomtat&oacute; men&uuml;i">
     A nyomtat&oacute; men&uuml;i
    </a>
   </p>
   <div id="divd0e6575">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_hu" title="Men&uuml;t&eacute;rk&eacute;p">
      Men&uuml;t&eacute;rk&eacute;p
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6905" title="Eszk&ouml;z">
      Eszk&ouml;z
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8910" title="Nyomtat&aacute;s">
      Nyomtat&aacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9824" title="Pap&iacute;r">
      Pap&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e10137" title="M&aacute;sol&aacute;s">
      M&aacute;sol&aacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e10470" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e12088" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e12771" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e13203" title="USB-meghajt&oacute;">
      USB-meghajt&oacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13822" title="H&aacute;l&oacute;zat/portok">
      H&aacute;l&oacute;zat/portok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15818" title="Biztons&aacute;g">
      Biztons&aacute;g
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_hu" title="Felhő csatlakoz&oacute;">
      Felhő csatlakoz&oacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e16547" title="Jelent&eacute;sek">
      Jelent&eacute;sek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_hu" title="Hibaelh&aacute;r&iacute;t&aacute;s">
      Hibaelh&aacute;r&iacute;t&aacute;s
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_hu" title="A nyomtat&oacute; karbantart&aacute;sa">
     A nyomtat&oacute; karbantart&aacute;sa
    </a>
   </p>
   <div id="divd0e16855">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_hu" title="Az alkatr&eacute;szek &eacute;s kell&eacute;kek &aacute;llapot&aacute;nak ellenőrz&eacute;se">
      Az alkatr&eacute;szek &eacute;s kell&eacute;kek &aacute;llapot&aacute;nak ellenőrz&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_hu" title="Kell&eacute;kanyagok &eacute;rtes&iacute;t&eacute;seinek konfigur&aacute;l&aacute;sa">
      Kell&eacute;kanyagok &eacute;rtes&iacute;t&eacute;seinek konfigur&aacute;l&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_hu" title="E-mail riaszt&aacute;sok be&aacute;ll&iacute;t&aacute;sa">
      E-mail riaszt&aacute;sok be&aacute;ll&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_hu" title="Jelent&eacute;sek megtekint&eacute;se">
      Jelent&eacute;sek megtekint&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_hu" title="Alkatr&eacute;szek &eacute;s kell&eacute;kek rendel&eacute;se">
      Alkatr&eacute;szek &eacute;s kell&eacute;kek rendel&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e17633" title="Alkatr&eacute;szek &eacute;s kell&eacute;kanyagok cser&eacute;je">
      Alkatr&eacute;szek &eacute;s kell&eacute;kanyagok cser&eacute;je
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e17882" title="Nyomtat&oacute;alkatr&eacute;szek tiszt&iacute;t&aacute;sa">
      Nyomtat&oacute;alkatr&eacute;szek tiszt&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e18036" title="Energia- &eacute;s pap&iacute;rtakar&eacute;koss&aacute;g">
      Energia- &eacute;s pap&iacute;rtakar&eacute;koss&aacute;g
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_hu" title="A nyomtat&oacute; &aacute;thelyez&eacute;se m&aacute;s helyre">
      A nyomtat&oacute; &aacute;thelyez&eacute;se m&aacute;s helyre
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_hu" title="A nyomtat&oacute; sz&aacute;ll&iacute;t&aacute;sa">
      A nyomtat&oacute; sz&aacute;ll&iacute;t&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_hu" title="Probl&eacute;m&aacute;k elh&aacute;r&iacute;t&aacute;sa">
     Probl&eacute;m&aacute;k elh&aacute;r&iacute;t&aacute;sa
    </a>
   </p>
   <div id="divd0e18193">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_hu" title="Nyomtat&aacute;si minős&eacute;ggel kapcsolatos probl&eacute;m&aacute;k">
      Nyomtat&aacute;si minős&eacute;ggel kapcsolatos probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_hu" title="Nyomtat&aacute;si probl&eacute;m&aacute;k">
      Nyomtat&aacute;si probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_hu" title="A nyomtat&oacute; nem v&aacute;laszol">
      A nyomtat&oacute; nem v&aacute;laszol
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_hu" title="Nem lehet olvasni a flash meghajt&oacute;t">
      Nem lehet olvasni a flash meghajt&oacute;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_hu" title="Az USB port enged&eacute;lyez&eacute;se">
      Az USB port enged&eacute;lyez&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e20762" title="H&aacute;l&oacute;zatikapcsolat-hib&aacute;k">
      H&aacute;l&oacute;zatikapcsolat-hib&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e20974" title="Kell&eacute;kanyagokkal kapcsolatos probl&eacute;m&aacute;k">
      Kell&eacute;kanyagokkal kapcsolatos probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_hu" title="Elakad&aacute;sok megsz&uuml;ntet&eacute;se">
      Elakad&aacute;sok megsz&uuml;ntet&eacute;se
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e21449" title="Pap&iacute;radagol&aacute;si probl&eacute;m&aacute;k">
      Pap&iacute;radagol&aacute;si probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e21816" title="E-mail-k&uuml;ld&eacute;si probl&eacute;m&aacute;k">
      E-mail-k&uuml;ld&eacute;si probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e21912" title="Faxol&aacute;si probl&eacute;m&aacute;k">
      Faxol&aacute;si probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e22550" title="Beolvas&aacute;si probl&eacute;m&aacute;k">
      Beolvas&aacute;si probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e23328" title="A sz&iacute;nminős&eacute;ggel kapcsolatos probl&eacute;m&aacute;k">
      A sz&iacute;nminős&eacute;ggel kapcsolatos probl&eacute;m&aacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_hu" title="Kapcsolatba l&eacute;p&eacute;s az &uuml;gyf&eacute;lszolg&aacute;lattal">
      Kapcsolatba l&eacute;p&eacute;s az &uuml;gyf&eacute;lszolg&aacute;lattal
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_hu" title="&Uacute;jrahasznos&iacute;t&aacute;s &eacute;s hullad&eacute;kkezel&eacute;s">
     &Uacute;jrahasznos&iacute;t&aacute;s &eacute;s hullad&eacute;kkezel&eacute;s
    </a>
   </p>
   <div id="divd0e23578">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_hu" title="Lexmark term&eacute;kek &uacute;jrahasznos&iacute;t&aacute;sa">
      Lexmark term&eacute;kek &uacute;jrahasznos&iacute;t&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_hu" title="A Lexmark csomagol&aacute;sok &uacute;jrahasznos&iacute;t&aacute;sa">
      A Lexmark csomagol&aacute;sok &uacute;jrahasznos&iacute;t&aacute;sa
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_hu" title="&Eacute;rtes&iacute;t&eacute;sek">
     &Eacute;rtes&iacute;t&eacute;sek
    </a>
   </p>
   <div id="divd0e23613">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23616" title="Term&eacute;kinform&aacute;ci&oacute;k">
      Term&eacute;kinform&aacute;ci&oacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23633" title="Megjegyz&eacute;s a kiad&aacute;shoz">
      Megjegyz&eacute;s a kiad&aacute;shoz
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_hu" title="V&eacute;djegyek">
      V&eacute;djegyek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_hu" title="Licencnyilatkozat">
      Licencnyilatkozat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_hu" title="Zajkibocs&aacute;t&aacute;si szintek">
      Zajkibocs&aacute;t&aacute;si szintek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_hu" title="Az elektromos &eacute;s elektronikus term&eacute;kekből keletkező hullad&eacute;kokra vonatkoz&oacute; (WEEE) direkt&iacute;va">
      Az elektromos &eacute;s elektronikus term&eacute;kekből keletkező hullad&eacute;kokra vonatkoz&oacute; (WEEE) direkt&iacute;va
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23742" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_hu" title="A term&eacute;k kidob&aacute;sa">
      A term&eacute;k kidob&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23776" title="&Uacute;jrat&ouml;lthető l&iacute;tium-ion elem">
      &Uacute;jrat&ouml;lthető l&iacute;tium-ion elem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_hu" title="(EU) 2023/1542 rendelet">
      (EU) 2023/1542 rendelet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_hu" title="A Lexmark fest&eacute;kkazett&aacute;k visszajuttat&aacute;sa &uacute;jb&oacute;li felhaszn&aacute;l&aacute;sra vagy &uacute;jrahasznos&iacute;t&aacute;sra">
      A Lexmark fest&eacute;kkazett&aacute;k visszajuttat&aacute;sa &uacute;jb&oacute;li felhaszn&aacute;l&aacute;sra vagy &uacute;jrahasznos&iacute;t&aacute;sra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_hu" title="Statikus &eacute;rz&eacute;kenys&eacute;ggel kapcsolatos figyelmeztet&eacute;s">
      Statikus &eacute;rz&eacute;kenys&eacute;ggel kapcsolatos figyelmeztet&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_hu" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_hu" title="Hőm&eacute;rs&eacute;kletadatok">
      Hőm&eacute;rs&eacute;kletadatok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_hu" title="Megjegyz&eacute;s a l&eacute;zerrel kapcsolatban">
      Megjegyz&eacute;s a l&eacute;zerrel kapcsolatban
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_hu" title="T&aacute;pfelv&eacute;tel">
      T&aacute;pfelv&eacute;tel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_hu" title="A telekommunik&aacute;ci&oacute;s v&eacute;gberendez&eacute;sekre vonatkoz&oacute; szab&aacute;lyok">
      A telekommunik&aacute;ci&oacute;s v&eacute;gberendez&eacute;sekre vonatkoz&oacute; szab&aacute;lyok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e24044" title="A vezet&eacute;k n&eacute;lk&uuml;li term&eacute;kekre vonatkoz&oacute; szab&aacute;lyok">
      A vezet&eacute;k n&eacute;lk&uuml;li term&eacute;kekre vonatkoz&oacute; szab&aacute;lyok
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_hu" title="Megjegyz&eacute;s a modul&aacute;ris &ouml;sszetevőkről">
      Megjegyz&eacute;s a modul&aacute;ris &ouml;sszetevőkről
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_hu" title="A r&aacute;di&oacute;frekvenci&aacute;s sug&aacute;rz&aacute;s hat&aacute;sa">
      A r&aacute;di&oacute;frekvenci&aacute;s sug&aacute;rz&aacute;s hat&aacute;sa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e24070" title="Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s">
      Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_hu" title="Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s">
      Az Eur&oacute;pai K&ouml;z&ouml;ss&eacute;g (EK) elő&iacute;r&aacute;sainak val&oacute; megfelel&eacute;s
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue